// the above line makes the linter ignore Sys.* errors, Sys DOES exist, it is part of ASP.Net, but logically it does NOT exist 'here'
// requires for external dependencies and other global stuff go here
/* eslint-disable no-unused-vars */

import _ from 'lodash';
import downloadRequestActivityLogger from './modules/downloadRequestActivityLogger';
import floatingLabels from './modules/floatingLabels';
import preTreatmentConfigurator from './modules/preTreatmentConfigurator';
import preTreatmentConfiguratorV2 from './modules/preTreatmentConfiguratorV2';

import productOverview from './modules/productOverview';
import { tns } from 'tiny-slider/src/tiny-slider';
import axios from 'axios';

import 'mdn-polyfills/Array.prototype.findIndex';
import 'mdn-polyfills/Element.prototype.closest';

/**
 * Bootstrap - Import ONLY if necessary
 **/
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/index';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/tooltip';
// import 'bootstrap/js/dist/util';

/* eslint-enable no-unused-vars */

// make sure Promise is present
require('es6-promise/auto');

/* eslint-disable */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}
floatingLabels.provideGlobal();
downloadRequestActivityLogger.provideGlobal();

// Init function, can be used for startup stuff
function init() {
    window.getProductDownloadUrls = function (culture, productId) {
        axios.get('/FRHandlers/ProductDownloadUrlHandler.ashx?pid=' + productId + '&culture=' + culture)
            .then(response => {
                try {
                    let hlDownloadPds = document.getElementById('hlDownloadPds');
                    if (hlDownloadPds && response && response.data && response.data.PDS) {
                        hlDownloadPds.setAttribute('data-toggle', '');
                        hlDownloadPds.setAttribute('data-target', '');
                        hlDownloadPds.setAttribute('target', '_blank');
                        hlDownloadPds.setAttribute('href', response.data.PDS);
                    }
                }
                catch(e) { };

                try {
                    let hlDownloadSds = document.getElementById('hlDownloadSds');
                    if (hlDownloadSds && response && response.data && response.data.SDS) {
                        hlDownloadSds.setAttribute('data-toggle', '');
                        hlDownloadSds.setAttribute('data-target', '');
                        hlDownloadSds.setAttribute('target', '_blank');
                        hlDownloadSds.setAttribute('href', response.data.SDS);
                    }
                }
                catch(e) { };
            });
    }
/* eslint-enable */

    var body = document.getElementsByTagName('BODY')[0];
    var toggleSearch = document.getElementById('toggleSearch');
    var toggleLanguage = document.getElementById('toggleLanguage');
    var toggleMainmenu = document.getElementById('toggleMainmenu');

    if (toggleSearch != null) {
        toggleSearch.addEventListener('click', function () {
            this.parentNode.classList.toggle('open');
            body.classList.toggle('open-search');
        });
    };
    if (toggleLanguage != null) {
        toggleLanguage.addEventListener('click', function () {
            this.parentNode.classList.toggle('open');
            body.classList.toggle('open-language');
        });
    };
    if (toggleMainmenu != null) {
        toggleMainmenu.addEventListener('click', function () {
            this.classList.toggle('open');
            body.classList.toggle('open-mainmenu');
        });
    };
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.nav-link-toggle *')) return;
        event.preventDefault();
        event.target.parentNode.parentNode.classList.toggle('show');
    }, false);
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.nav-link.dropdown-toggle *')) return;
        if (event.target.closest('.dropdown-menu')) return;
        if (event.target.closest('.dropdown-submenu')) return;
        event.preventDefault();
        event.target.parentNode.parentNode.classList.toggle('show');
    }, false);

    // menuoutclickfunction

    let opened = null;
    const toggleVisibility = e => {
        e.classList.toggle('show');
        e.parentNode.classList.toggle('show');
    };

    const handleDropdown = e => {
        const clickedItem = e.parentNode.lastChild.previousSibling;
        toggleVisibility(clickedItem);
        if (!opened) {
            opened = clickedItem;
        } else if (opened === clickedItem) {
            opened = null;
        } else {
            toggleVisibility(opened);
            opened = clickedItem;
        }
    };

    const handleClick = e => {
        if (_.includes(e.target.className, 'dropdown-toggle')) {
            e.preventDefault();
            handleDropdown(e.target);
        } else if (opened) {
            toggleVisibility(opened);
            opened = null;
        }
    };

    document.querySelector('body').addEventListener('click', handleClick);

    // Scrollfunction for all anchor links
    function anchorLinkHandler(e) {
        const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);

        e.preventDefault();
        const targetID = this.getAttribute('href');
        const targetAnchor = document.querySelector(targetID);
        if (!targetAnchor) return;
        const originalTop = distanceToTop(targetAnchor);

        window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });

        const checkIfDone = setInterval(function () {
            if (isScrolling === false) {
                targetAnchor.tabIndex = '-1';
                targetAnchor.focus();
                window.history.pushState('', '', targetID);
                clearInterval(checkIfDone);
            }
        }, 100);
    }
    const linksToAnchors = document.querySelectorAll('.scroll-link');
    try {
        // this line triggers an error when unit testing JS... Ignore for now.
        linksToAnchors.forEach(each => (each.onclick = anchorLinkHandler));
    }
    catch (e) {
    }

    // Show Hide menu when scroll Up Down
    let scrollPos = 0;
    const nav = document.querySelector('header');

    function checkPosition() {
        let windowY = document.documentElement.scrollTop;
        if (document.documentElement.scrollTop > 1) {
            if (windowY < scrollPos) {
                // Scrolling UP
                nav.classList.add('is-visible');
                nav.classList.remove('is-hidden');
            } else if (windowY > scrollPos) {
                // Scrolling DOWN
                nav.classList.add('is-hidden');
                nav.classList.remove('is-visible');
            }
        } else {
            // Initially scrolled down
            nav.classList.add('is-hidden');
            nav.classList.remove('is-visible');
        }
        scrollPos = windowY;
    }

    function debounce(func, wait = 10, immediate = true) {
        let timeout;
        return function () {
            let context = this;
            let args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    // Add class to body when document scroll > 50
    function scrollFunction() {
        if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1 || document.documentElement.scrollTop > 1) {
            document.body.classList.add('scroll50');
        } else {
            document.body.classList.remove('scroll50');
            nav.classList.remove('is-visible');
        }
    }

    let isScrolling = false;
    var delay = 200;
    var scrollTimeout = null;
    function checkIfScrolling() {
        isScrolling = true;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
            isScrolling = false;
        }, delay);
    }

    try {
        checkPosition();
        scrollFunction();
        window.addEventListener('scroll', debounce(checkPosition));
        window.addEventListener('scroll', scrollFunction);
        window.addEventListener('scroll', checkIfScrolling);
    }
    catch (e) {
    }

    function handleVideoPauseOrPlay() {
        var videoControlsEl = document.querySelector('.video-controls');
        if (videoControlsEl) {
            var videoEl = document.querySelector('.b-header video');
            var videoPauseBtn = videoControlsEl.querySelector('.video-pause-btn');
            var videoPlayBtn = videoControlsEl.querySelector('.video-play-btn');
            videoPauseBtn.addEventListener('click', (x) => {
                videoEl.pause();
                videoPauseBtn.classList.add('d-none');
                videoPlayBtn.classList.remove('d-none');
            });
            videoPlayBtn.addEventListener('click', (x) => {
                videoEl.play();
                videoPauseBtn.classList.remove('d-none');
                videoPlayBtn.classList.add('d-none');
            });
        }
    }

    try {
        handleVideoPauseOrPlay();
    }
    catch (e) {
        console.log(e);
    }

    try {
        var caseSlider = document.getElementsByClassName('case-slider');
        // this line triggers an error when unit testing JS... Ignore for now.
        /* eslint-disable no-unused-vars */
        if (caseSlider.length > 0) {
            var caseslider = tns({
                container: '.case-slider',
                controls: true,
                items: 1,
                center: true,
                loop: true,
                mouseDrag: true,
                nav: false,
                gutter: 70,
                controlsText: ['', ''],
                prevButton: '.case-prev-btn',
                nextButton: '.case-next-btn',
                fixedWidth: 275,
                responsive: {
                    576: {
                        fixedWidth: 510
                    },
                    768: {
                        fixedWidth: 690
                    },
                    992: {
                        fixedWidth: 930
                    },
                    1024: {
                        items: 2
                    },
                    1500: {
                        fixedWidth: 1160
                    }
                }
            });
        };
        /* eslint-enable no-unused-vars */
    }
    catch (e) {
    }

    try {
        var productSlider = document.getElementsByClassName('product-slider');
        // this line triggers an error when unit testing JS... Ignore for now.
        /* eslint-disable no-unused-vars */
        if (productSlider.length > 0) {
            var productslider = tns({
                container: '.product-slider',
                controls: true,
                items: 1,
                mouseDrag: true,
                nav: false,
                rewind: true,
                controlsText: ['', ''],
                prevButton: '.product-prev-btn',
                nextButton: '.product-next-btn'
            });

            productslider.events.on('indexChanged', currentSlideValues);
            currentSlideValues();
        };
        /* eslint-enable no-unused-vars */
    }
    catch (e) {
    }

    function currentSlideValues() {
        document.getElementById('currentslide').innerHTML = productslider.getInfo().index + 1;
        document.getElementById('totalslides').innerHTML = productslider.getInfo().slideCount;
    };

    try {
        var partnerSlider = document.getElementsByClassName('partner-slider');
        // this line triggers an error when unit testing JS... Ignore for now.
        /* eslint-disable no-unused-vars */
        if (partnerSlider.length > 0) {
            var partnerslider = tns({
                container: '.partner-slider',
                controls: true,
                items: 1,
                center: false,
                loop: true,
                mouseDrag: true,
                autoplay: true,
                autoplayButtonOutput: false,
                nav: false,
                gutter: 0,
                controlsText: ['', ''],
                prevButton: '.partner-prev-btn',
                nextButton: '.partner-next-btn',
                responsive: {
                    768: {
                        items: 2,
                        gutter: 50
                    },
                    992: {
                        items: 4
                    }
                }
            });
        };
        /* eslint-enable no-unused-vars */
    }
    catch (e) {
    }

    try {
        // this line triggers an error when unit testing JS... Ignore for now.
        const sabaForm = document.getElementsByClassName('b-form');
        if (sabaForm != null) {
            floatingLabels.setup(sabaForm);
        }
    }
    catch (e) {
    }

    const preTreatmentConfiguratorEl = document.getElementById('preTreatmentConfigurator');
    if (preTreatmentConfiguratorEl) {
        preTreatmentConfigurator.init('preTreatmentConfigurator');
    }

    const preTreatmentConfiguratorV2El = document.getElementById('preTreatmentConfiguratorV2');
    if (preTreatmentConfiguratorV2El) {
        preTreatmentConfiguratorV2.init('preTreatmentConfiguratorV2');
    }

    const productOverviewEl = document.getElementById('productOverview');
    if (productOverviewEl) {
        productOverview.init('productOverview');
    }

    try {
        // Handler that uses various data-* attributes to trigger
        // specific actions, mimicing bootstraps attributes
        const triggers = [].slice.call(document.querySelectorAll('[data-toggle="collapse"]'));
        window.addEventListener('click', (ev) => {
            const elm = ev.target;
            if (_.includes(triggers, elm)) {
                const selector = elm.getAttribute('data-target');
                collapse(selector, 'toggle');
                elm.classList.toggle('collapsed');
            }
        }, false);

        const fnmap = {
            'toggle': 'toggle',
            'show': 'add',
            'hide': 'remove'
        };
        const collapse = (selector, cmd) => {
            const targets = [].slice.call(document.querySelectorAll(selector));
            targets.forEach(target => {
                target.classList[fnmap[cmd]]('show');
            });
        };
    }
    catch (e) {
    }

    try {
        const productDownloadsEl = document.getElementById('productdownloads');
        if (productDownloadsEl) {
            const toProductDownloadsLink = document.getElementById('toproductdownloads');
            const toProductDownloadsNavLink = document.getElementById('toproductdownloadsnav');
            toProductDownloadsLink.classList.remove('d-none');
            toProductDownloadsNavLink.classList.remove('d-none');

            downloadRequestActivityLogger.init(productDownloadsEl);
        }
    }
    catch (e) {
    }

    try {
        const mediaDownloadsEl = document.getElementById('mediafiledownload');
        if (mediaDownloadsEl) {
            downloadRequestActivityLogger.initMediaFile(mediaDownloadsEl);
        }
    }
    catch (e) {
    }

    try {
        const relatedProductsEl = document.getElementById('relatedproducts');
        if (relatedProductsEl) {
            const toRelatedProductsLink = document.getElementById('torelatedproducts');
            toRelatedProductsLink.classList.remove('d-none');
        }
    }
    catch (e) {
    }
}

export default {
    init
};
